import { useMutation } from "react-query";
import { Post } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";

interface SendReorderEmailData {
  to_email: string;
  subject: string;
  body: string;
  recipient_organization_id?: string;
}

export default (organizationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useMutation(
    async (emailData: SendReorderEmailData) => {
      return await Post(
        `/api/order/organization/${organizationId}/send-reorder-email`,
        await getAccessTokenSilently(),
        emailData
      );
    }
  );
};
